import { makeAutoObservable } from 'mobx';
import { RootStore } from './RootStore';

/**
 * UIStore - Global UI state management
 * Handles error messages, success messages, and dialog/panel visibility states
 */
export class UIStore {
  rootStore: RootStore;
  
  // Error and success messages
  error: string | null = null;
  successMessage: string | null = null;
  
  // Dialog and panel visibility states
  isUploadDialogOpen = false;
  isViewPanelOpen = false;
  isEditPanelOpen = false;
  isDeleteDialogOpen = false;
  isRecycleBinOpen = false;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  // Error handling actions
  setError = (message: string) => {
    this.error = message;
  };

  clearError = () => {
    this.error = null;
  };

  // Success message actions
  setSuccessMessage = (message: string) => {
    this.successMessage = message;
  };

  clearSuccessMessage = () => {
    this.successMessage = null;
  };

  // Upload dialog actions
  openUploadDialog = () => {
    this.isUploadDialogOpen = true;
  };

  closeUploadDialog = () => {
    this.isUploadDialogOpen = false;
  };

  // View panel actions
  openViewPanel = () => {
    this.isViewPanelOpen = true;
  };

  closeViewPanel = () => {
    this.isViewPanelOpen = false;
  };

  // Edit panel actions
  openEditPanel = () => {
    this.isEditPanelOpen = true;
  };

  closeEditPanel = () => {
    this.isEditPanelOpen = false;
  };

  // Delete dialog actions
  openDeleteDialog = () => {
    this.isDeleteDialogOpen = true;
  };

  closeDeleteDialog = () => {
    this.isDeleteDialogOpen = false;
  };

  // Recycle Bin actions
  openRecycleBin = () => {
    this.isRecycleBinOpen = true;
  };

  closeRecycleBin = () => {
    this.isRecycleBinOpen = false;
  };
}

